import { sheets_v4 } from 'googleapis'
import { Temporal } from '@imago/api-client'

type GString = {stringValue: string}
type GNumber = {numberValue: number}

const Instant__Brand: unique symbol = Symbol()
type GNumberForInstant = GNumber & {[Instant__Brand]: never}

const googleEpoch = Temporal.Instant.from('1899-12-30T00:00:00Z')

export function toInstant(val: GNumberForInstant ): Temporal.Instant;
export function toInstant(val: GNumberForInstant | undefined): Temporal.Instant | undefined;

export function toInstant(val: GNumberForInstant | undefined) {
	if (val === undefined) return undefined
	return googleEpoch.add({seconds: Math.round(val.numberValue * 24 * 60 * 60)})
}

type GooglifyType<T> =
	T extends Temporal.Instant ? GNumberForInstant :
	T extends number ? GNumber :
	T extends string ? GString :
	T extends undefined ? undefined :
	never

export type GoogleInfo<RawInfo> = {[k in keyof RawInfo]: GooglifyType<RawInfo[k]>}

export function parseSheet<T>(sheet: sheets_v4.Schema$Sheet, parseGInfo: (o: any) => T) {
	const rows = sheet.data![0]!.rowData!
	const rawHeader = rows.shift()!

	const header = rawHeader.values!.map(v => v.formattedValue ?? '')
	header[0] = 'id'
	return (rows.map(row => row.values!.map(value => value.effectiveValue)).filter(row => row[0])).map(row => parseGInfo((Object.fromEntries(header.map((h, i) => [h, row[i]])) as any)))
}
